import receiptsModule from './receipts/module';
import budgetModule from './budget/module';
import familyModule from './family/module';

export const allModules = [receiptsModule, budgetModule, familyModule];

export default allModules;
